import { render } from "./VoteButtons.vue?vue&type=template&id=5cf4509c&scoped=true"
import script from "./VoteButtons.vue?vue&type=script&lang=js"
export * from "./VoteButtons.vue?vue&type=script&lang=js"

import "./VoteButtons.vue?vue&type=style&index=0&id=5cf4509c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf4509c"],['__file',"resources/js/components/VoteButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cf4509c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cf4509c', __exports__)) {
    api.reload('5cf4509c', __exports__)
  }
  
  module.hot.accept("./VoteButtons.vue?vue&type=template&id=5cf4509c&scoped=true", () => {
    api.rerender('5cf4509c', render)
  })

}


export default __exports__